<template>
  <div>
    <table
      class="ui celled very compact selectable striped table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>#</th>
          <th>{{ $t("module") }}</th>
          <th>{{ $t("granted") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(mdle, index) in modules" :key="index">
          <td>
            {{ mdle.module_id }}
          </td>
          <td>
            {{ $t(mdle.setup.name) }}
          </td>
          <td>
            <div class="ui toggle checkbox" ref="check_obj" :data-i="index">
              <input
                type="checkbox"
                name="public"
                v-model="modules[index].granted"
              />
              <label></label>
            </div>
            <span style="opacity: 0.1">{{
              modules[index].granted ? "." : ","
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { local_api, toast } from "@/utils";

export default {
  name: "",
  data() {
    return {
      modules: [],
    };
  },
  props: {
    role: Object,
  },
  mounted() {},
  methods: {
    init(role_id) {
      console.log("initing with", role_id);
      let vm = this;
      local_api(vm, "post", "/role_module_suscription/do-get-list", {
        u: role_id,
      })
        .then((list) => {
          vm.modules = list.filter((m) => {
            return (
              m.usr_module_suscriptions && m.usr_module_suscriptions.length > 0
            );
          });
          // vm.modules = list.map((itm) => {
          //   itm.granted = false;
          //   return itm;
          // });
          setTimeout(() => {
            vm.init_table();
          }, 500);
        })
        .catch((err) => {
          toast(vm.$el, "error", err);
        })
        .finally(() => {});
    },
    init_table() {
      let vm = this;
      let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
      if (vm.$i18n.locale == "es")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
      else if (vm.$i18n.locale == "fr")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";
      window.jQuery(vm.$refs.table).DataTable({
        language: {
          url: dict,
          order: [[0, "desc"]],
        },
      });

      vm.$emit("updated", vm.modules);

      vm.$refs.check_obj.forEach((element) => {
        window.jQuery(element).checkbox({
          onChecked() {
            let index = window.jQuery(this).closest(".ui.checkbox").data("i");
            let trgt = vm.modules[index];

            if (trgt) {
              local_api(vm, "post", "/role_module_suscription/do-suscribe", {
                m: trgt.module_id,
                r: vm.role.role_id,
              })
                .then(() => {
                  vm.$emit("updated", vm.modules);
                })
                .catch((err) => {
                  toast(vm.$el, "error", err);
                })
                .finally(() => {});
            }
          },
          onUnchecked() {
            let index = window.jQuery(this).closest(".ui.checkbox").data("i");
            let trgt = vm.modules[index];

            if (trgt) {
              local_api(vm, "post", "/role_module_suscription/do-unsuscribe", {
                m: trgt.module_id,
                r: vm.role.role_id,
              })
                .then(() => {
                  vm.$emit("updated", vm.modules);
                })
                .catch((err) => {
                  toast(vm.$el, "error", err);
                })
                .finally(() => {});
            }
          },
        });
      });
    },
    unsuscribe(suscription, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete suscription?"),
        function () {
          local_api(vm, "post", "/user_role_suscription/do-unsuscribe", {
            s: suscription.encrypted_id,
          })
            .then(() => {
              // console.log(response);
              vm.role.usr_role_suscriptions.splice(index, 1);
            })
            .catch((err) => {
              toast(vm.$el, "error", err);
            })
            .finally(() => {});
        },
        function () {},
      );
    },
  },
};
</script>
